<template>
    <form-field v-bind="fieldProps">
        <text-editor-input
            v-bind="inputProps"
            @change="change($event)"
            @emitEvent="emitEvent($event, ['change'])"
        ></text-editor-input>

        <template #hint>
            <slot name="hint"></slot>
        </template>

        <template #right>
            <slot name="right"></slot>
        </template>

        <template #error="{ error }">
            <slot name="error" :error="error"></slot>
        </template>
    </form-field>
</template>

<script>
    import FormFieldMixin from 'mixins/FormFieldMixin'
    import FormPrefillingMixin from 'mixins/FormPrefillingMixin'

    export default {
        mixins: [FormFieldMixin, FormPrefillingMixin],

        props: {
            placeholder: { type: String, default: undefined },
            uploadedFiles: { type: Array, required: true },
            attachmentHintText: { type: String, default: '' },
            attachmentHintHeader: { type: String, default: '' },
            overlayText: { type: String, default: '' },
        },
    }
</script>
